import React from "react";
import { Content } from "src/styles";
import { WorkRequestTabsProps } from "../types";
import WorkRequestTab from "./WorkRequestTab";
import { StatusTabButton, StatusTabsBar, TabPanel } from "../styles";

const WorkRequestTabs = ({
  activeTab,
  setActiveTab,
  tabs,
  siblingCount,
  pageSize,
  isRedirectToDetailPageAllowed,
  renderTable,
}: WorkRequestTabsProps) => {
  if (tabs.length === 1) {
    return (
      <Content>
        <WorkRequestTab
          siblingCount={siblingCount}
          workRequestType={activeTab}
          pageSize={pageSize}
          renderTable={renderTable}
        />
      </Content>
    );
  }
  return (
    <Content>
      <StatusTabsBar>
        {tabs.map((tab) => (
          <StatusTabButton
            key={tab.eventKey}
            $active={activeTab === tab.eventKey}
            onClick={() => setActiveTab(tab.eventKey)}
            type="button"
          >
            {tab.label}
          </StatusTabButton>
        ))}
      </StatusTabsBar>
      <TabPanel>
        <WorkRequestTab
          siblingCount={siblingCount}
          workRequestType={activeTab}
          pageSize={pageSize}
          isRedirectToDetailPageAllowed={isRedirectToDetailPageAllowed}
          renderTable={renderTable}
        />
      </TabPanel>
    </Content>
  );
};

export default WorkRequestTabs;
